export const environment = {
    ENVIRONMENT: 'dev',
    CHATBOT_BASE_URL: 'https://dev-chatbot.nopalcyber.com',
    CHATBOT_BUILD_VERSION: '1.0.0',
    DOMAIN_PREFIX: 'dev-chatbot-app',
    DOMAIN: 'nopalcyber.com',
    CHATBOT_CLOUD_FRONT_URL :'https://djgttwd1rcako.cloudfront.net'
};